export function validateWarrantyIdentifictionNum(idNum) {
  const regex = /^rl[a-zA-Z0-9]{2,10}$/i;
  return regex.test(idNum);
}
